<template>
  <g :id="hand.id">
    <path fill="#332D2F" d="M69.2639,111.948c-1.0946-1.5168-0.7524-3.6337,0.7644-4.7283c0.5757-0.4155,1.2675-0.6396,1.9775-0.6405
      c1.8702-0.0018,3.3877,1.5129,3.3894,3.383c0.0018,1.8702-1.5129,3.3877-3.383,3.3894
      C70.9238,113.3527,69.9011,112.8304,69.2639,111.948z M73.5167,108.878c-0.6003-0.8329-1.7623-1.0215-2.5952-0.4212
      c-0.833,0.6004-1.0215,1.7623-0.4212,2.5952c0.6003,0.8329,1.7623,1.0215,2.5952,0.4212
      c0.4854-0.3498,0.7727-0.9119,0.7721-1.5101C73.8687,109.5733,73.7458,109.1934,73.5167,108.878z"/>
    <path fill="#595A5C" d="M74.7672,107.9743l-0.0254,0.0184c1.0897,1.5088,0.7499,3.6154-0.7589,4.7051
      c-0.5734,0.4141-1.2627,0.6373-1.97,0.638c-1.0831-0.0005-2.1003-0.5198-2.7358-1.3968
      c-1.0896-1.5089-0.7498-3.6154,0.7591-4.7051c0.5734-0.4141,1.2625-0.6373,1.9698-0.6379
      c1.083,0.0006,2.1003,0.5199,2.736,1.3969l0.0255-0.0184 M70.4896,111.0631c0.6059,0.8392,1.7775,1.0284,2.6168,0.4225
      c0.4886-0.3528,0.7778-0.919,0.7772-1.5217c0.0006-0.3935-0.1235-0.777-0.3546-1.0954c-0.606-0.8393-1.7777-1.0284-2.6169-0.4223
      c-0.4886,0.3528-0.7777,0.9191-0.7771,1.5218C70.1345,110.3613,70.2587,110.7448,70.4896,111.0631 M74.7672,107.9743
      c-1.0996-1.5234-3.2259-1.8668-4.7493-0.7672c-1.5234,1.0996-1.8668,3.2259-0.7672,4.7493
      c1.0996,1.5234,3.2259,1.8668,4.7493,0.7672c0.8868-0.6402,1.4117-1.6676,1.4107-2.7614
      C75.4105,109.2485,75.1853,108.5529,74.7672,107.9743z M70.5152,111.0446c-0.5958-0.8252-0.4097-1.9771,0.4154-2.5728
      c0.8251-0.5957,1.9771-0.4097,2.5728,0.4154c0.5958,0.8252,0.4097,1.9771-0.4154,2.5728
      c-0.3134,0.2263-0.69,0.3483-1.0766,0.3487C71.4185,111.8107,70.8613,111.526,70.5152,111.0446z"/>
    <polygon fill="#FFFFFF" points="69.1714,99.7618 71.9807,84.0232 74.8257,99.7559 73.4977,106.6799 70.5144,106.6828 			"/>
    <path fill="#332D2F" d="M71.9841,86.4282l2.4089,13.325l-1.2472,6.5022l-2.2812,0.0027l-1.2605-6.4996l2.3802-13.3301
       M71.9792,81.6197l-3.2405,18.1455l1.4247,7.3447l3.685-0.0042l1.4095-7.3478l-3.2791-18.1384L71.9792,81.6197z"/>
    <rect x="70.1638" y="102.8784" transform="matrix(1 -0.0011 0.0011 1 -0.112 0.0768)" fill="#332D2F" width="3.685" height="4.5378"/>
  </g>
</template>

<script>
export default {
  name: 'sdHandHour',
  props: ['data'],
  computed: {
    hand() {
      if (this.data.hand) return this.data.hand;
    },
    watch() {
      if (this.data.watch) return this.data.watch;
    },
  },
};
</script>
